var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMonorail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 795 463.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill-rule:evenodd;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M296,142c0,2.21,1.79,4,4,4h22.62l47.44,118.33c-13.89,9.11-23.06,24.82-23.06,42.67,0,23.49,15.89,43.28,37.5,49.19v1.2c0,7.03-2.79,13.77-7.76,18.74l-8.8,8.8c-17.98,17.99-17.98,47.14,0,65.13,17.98,17.98,47.14,17.98,65.13,0l3.75-3.75c15.91-15.91,15.91-41.71,0-57.63l-22.63,22.63c3.42,3.42,3.42,8.96,0,12.37l-3.75,3.75c-5.49,5.49-14.39,5.49-19.87,0-5.49-5.49-5.49-14.38,0-19.87l8.8-8.8c10.97-10.97,17.13-25.85,17.13-41.37v-2.85c19.02-7.41,32.5-25.9,32.5-47.54,0-17.7-9.02-33.3-22.71-42.44l48.3-118.56h20.41c2.21,0,4-1.79,4-4V4c0-2.21-1.79-4-4-4h-195c-2.21,0-4,1.79-4,4V142Zm140.04,4h-74.94l37.17,92.71,37.77-92.71Zm342.96-26h-249V24h225c22.09,0,40,17.91,40,40v40c0,8.84-7.16,16-16,16ZM265,24V120H16c-8.84,0-16-7.16-16-16v-40C0,41.91,17.91,24,40,24h225Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonorail);
export default __webpack_public_path__ + "static/media/monorail.851a9e63cfaa37db3771373c9e441d43.svg";
export { ForwardRef as ReactComponent };